import styled from 'styled-components';

export const Container = styled.div`
  .tags-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
  }
`;
